// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCloneWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyCloneResponseWebDto } from '../..';

interface CloneParams {
  fullAddress: string;
  listingAlias: ListingAlias;
  unit?: string;
}

export const RentalManagerUserPropertyCloneWebApiHandler_clone_Path = '/api/web/v1/users/properties/clone';

/**
 * Clone a property
 */
export const RentalManagerUserPropertyCloneWebApiHandler_clone = (getParams: CloneParams, client = getClient()) => {
  return httpFrontEndRequest<CloneParams, never, UserPropertyCloneResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyCloneWebApiHandler_clone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
